import {
  MODAL_ACTION,
  TABLE_GRID,
  jobNameMap,
  jobStateToBadgeVariant,
  jobTypeMap,
  mapDataTypeToLabel,
} from 'modules/jobManager/constants';
import { useJobManagerTranslations } from 'modules/jobManager/hooks';
import { JOB_STATE, JOB_TYPE, TableRow as TableRowType } from 'modules/jobManager/types';
import { formatDateForName, formatDate } from 'modules/jobManager/utils';
import { GridRow } from 'ui/indexPages/tables/grid';
import { ActionMenu } from 'ui/actionMenu/ActionMenu';
import { AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { colors } from 'ui/theme/colors';
import { Delete } from 'ui/icons/action/Delete';
import { Overflow } from 'ui/icons/navigation/Overflow';
import { Badge } from 'ui/badge';
import { useModalContext } from 'utils/contexts/modal';
import { DoubleLineCell, NameCell, SingleLineCell } from './cells';
import { CaptionText } from './cells/Styled';
import { StyledButton } from './Styled';

export const TableRow = ({ row }: { row: TableRowType }) => {
  const { t } = useJobManagerTranslations();
  const { showModal } = useModalContext();
  const jobName = `${jobNameMap[row.jobTypeName]} ${formatDateForName(row.createdAt)}`;
  const jobType = jobTypeMap[row.jobTypeName];
  const startTime = formatDate(row.scheduledStartTime);
  const endTime = formatDate(row.endTime);
  const isDeletable = [JOB_STATE.ENQUEUED, JOB_STATE.RUNNING].includes(row.jobState);

  const cancelContent = (
    <>
      <Delete height={16} />
      <span>{t('table.action.cancel')}</span>
    </>
  );

  return (
    <GridRow gridLayout={TABLE_GRID}>
      <SingleLineCell>{row.id}</SingleLineCell>
      <NameCell name={jobName} data={row.jobData} />
      <DoubleLineCell
        title={jobType}
        subTitle={
          row.jobTypeName === JOB_TYPE.EXPORT_JOB ? mapDataTypeToLabel[row.jobData?.dataType] : ''
        }
      />
      <SingleLineCell>
        <Badge variant={jobStateToBadgeVariant[row.jobState]}>{row.jobState}</Badge>
      </SingleLineCell>
      <SingleLineCell>{row.organizationId}</SingleLineCell>
      <SingleLineCell>{row.projectId}</SingleLineCell>
      <DoubleLineCell
        title={row.recurringJobId ? t('bool.true') : t('bool.false')}
        subTitle={row.recurringJobId ? row.recurringJobId.toString() : ''}
      />
      <SingleLineCell>{startTime}</SingleLineCell>
      <SingleLineCell>
        {row.endTime ? endTime : <CaptionText>{t('noData.NA')}</CaptionText>}
      </SingleLineCell>
      {isDeletable && (
        <ActionMenu
          align={MENU_ALIGNMENTS.RIGHT}
          options={[
            {
              id: 'cancel',
              as: AllowedActionMenuElements.Button,
              content: cancelContent,
              onClick: () =>
                showModal({
                  action: MODAL_ACTION.CANCEL_JOB,
                  id: row.id,
                }),
            },
          ]}
          style={{ display: 'flex', justifyContent: 'flex-end' }}
        >
          <StyledButton onClick={() => null}>
            <Overflow color={colors.grey90} />
          </StyledButton>
        </ActionMenu>
      )}
    </GridRow>
  );
};
